import {Directive, ElementRef, Input, OnChanges} from '@angular/core';

/*
This directive helps angular get to know that img src was
actually updated. It is needed because when we change img
the actual src does not change, so on next change detection
we tell angular that it may be new img, and please show it
* */
@Directive({
  selector: '[mcImgCacheBuster]',
  standalone: true,
})
export class ImgCacheBusterDirective implements OnChanges {
  @Input() src: string = '';

  constructor(private el: ElementRef<HTMLImageElement>) {}

  ngOnChanges(): void {
    this.reloadImage();
  }

  private reloadImage(): void {
    this.el.nativeElement.src = this.src + '?' + Date.now(); // Update the src attribute
  }
}
